module.exports = __webpack_public_path__ + "img/vi_identity_card_bg1.7f0e5918.png";